import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function CustomEntityRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Custom Entity Record Batch" />;
}
